export default __webpack_public_path__ + "static/media/5.1994b7b6.png";